'use strict';

/**
 * All JS for any action of the UsersController on the server side
 */
waApp.controllers.Users = {
	dashboard: function() {
		$('.job-prices-trigger').click(function() {
			$('.job-prices-element').toggle();
			$('.job-trigger-hide').toggle();
			$('.job-trigger-show').toggle();
		});

        // if (localStorage.trigger_affected_prices) {
        //     if (localStorage.trigger_affected_prices < 3) {
        //         $('#newPriceAffected').modal('show');
        //         localStorage.trigger_affected_prices = Number(localStorage.trigger_affected_prices)+1;
        //     }
        // } else {
        //     $('#newPriceAffected').modal('show');
        //     localStorage.trigger_affected_prices = 1;
        // }
	},
	registerCompany: function() {
		waApp.controllers.Users.register();
	},
	registerPersonal: function() {
		waApp.controllers.Users.register();
	},
	register: function() {
		// Check if company is present
		if ($('#company-country-id').length) {
			let countryInput = $('#company-country-id');
			let stateInput = $('#company-state-id');
			let userLanguage = $('#user-profile-language-id');
			let companyLanguage = $('#company-invoice-language-id');

			waUtils.postalCodeVsZipCode('#company-country-id', '#company-postal-code');

			countryInput.select2({
				placeholder: countryInput.attr('placeholder'),
				allowClear: true
			});

			stateInput.select2({
				placeholder: stateInput.attr('placeholder'),
				allowClear: true
			});

			userLanguage.select2({
				placeholder: stateInput.attr('placeholder'),
				allowClear: true
			});

			companyLanguage.select2({
				placeholder: stateInput.attr('placeholder'),
				allowClear: true
			});

			waUtils.stateSelect('#company-country-id', '#company-state-id');
		}

		let countryInput = $('#user-profile-country-id');
		let stateInput = $('#user-profile-state-id');

		countryInput.select2({
			placeholder: countryInput.attr('placeholder'),
			allowClear: true
		});

		if (stateInput.length) {
			stateInput.select2({
				placeholder: stateInput.attr('placeholder'),
				allowClear: true
			});

			waUtils.stateSelect('#user-profile-country-id', '#user-profile-state-id');
		}

		$('#company-company-type-id').select2({
			placeholder: $('#company-company-type-id').attr('placeholder'),
			allowClear: true
		});

		$('#user-profile-job-position-id').select2({
			placeholder: $('#user-profile-job-position-id').attr('placeholder'),
			allowClear: true
		});

		$('#user-profile-title-id').select2({
			placeholder: $('#user-profile-title-id').attr('placeholder'),
			allowClear: true
		});

		$('#company-registration, #personal-registration').on('keyup', 'input[type=password]', function(event) {
			waUtils.passwordMatchValidtion('#password', '#confirm-password');
		});

		$('#company-url').blur(function() {
			let url = $(this).val();
			$(this).val(waUtils.addHttpPrefix(url));
		});
	},
	settings: function() {
		let userLanguage = $('#user-profile-language-id');
		let companyLanguage = $('#company-invoice-language-id');
		let stateInput = $('#user-profile-state-id');

		userLanguage.select2({
			placeholder: stateInput.attr('placeholder'),
			allowClear: true
		});

		companyLanguage.select2({
			placeholder: stateInput.attr('placeholder'),
			allowClear: true
		});

		$('#company-country-id').select2({
			placeholder: $('#company-country-id').attr('placeholder'),
			allowClear: true
		});
		$('#company-state-id').select2({
			placeholder: $('#company-state-id').attr('placeholder'),
			allowClear: true
		});

		$('#user-profile-country-id').select2();
		$('#user-profile-state-id').select2();

		// We handle the case when the same view is displayed for the
		// company and regular user. This would throw otherwise an
		// exception when the page is missing the company
		try {
			waUtils.stateSelect('#company-country-id', '#company-state-id');
		} catch (error) {
		}

		waUtils.stateSelect('#user-profile-country-id', '#user-profile-state-id');
	},
	changePassword: function() {
		$('#change-password-form').on('keyup', 'input[type=password]', function(event) {
			waUtils.passwordMatchValidtion('#password', '#confirm-password');
		});
	}
};
